/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon24Solid = forwardRef('MediaUiAPlayIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.59 10.511 7.897 3.291C6.633 2.507 5 3.418 5 4.906v14.186c0 1.488 1.633 2.399 2.898 1.617l11.691-7.221a1.75 1.75 0 0 0 0-2.978Z" })));
});
